<template>
  <div>
    <div class="md-layout md-gutter report-types">
      <div class="md-layout-item">
        <md-field>
          <label for="tileType">{{ $t('report.report_types') }}</label>
          <md-select
            v-model="selectedReportType"
            @md-selected="onReportTypesChanged"
            name="reportType"
            id="reportType"
          >
            <md-option
              v-for="report of reportTypes"
              :key="report.key"
              :value="report.key"
            >
              {{ $t(report.value) }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <ReportTable
      v-if="isShowReportTable"
      :isReportDataLoading="isReportDataLoading"
      :reportName="selectedReportName"
    ></ReportTable>
  </div>
</template>
<script>
import {ReportTable} from '@/components/viewReport'
export default {
  name: 'Reports',
  components: {ReportTable},

  data() {
    return {
      selectedReportType: 'none',
      reportTypes: [],
      isReportDataLoading: true
    }
  },
  props: {
    report_type: {
      type: String,
      required: true
    }
  },

  async created() {
    try {
      const list = await this.$store.dispatch('LOAD_REPORTS_LIST')
      this.reportTypes = [...list]

      if (this.report_type !== 'list') {
        this.selectedReportType = this.report_type
      }
    } catch (err) {
    } finally {
    }
  },
  methods: {
    async onReportTypesChanged(type) {
      this.$router.push({path: `/reports/${type}`})

      this.isReportDataLoading = true

      try {
        await this.$store.dispatch('LOAD_REPORT_DATA', type)
      } finally {
        this.isReportDataLoading = false
      }
    }
  },
  computed: {
    isShowReportTable() {
      return this.report_type !== 'list'
    },
    selectedReportName() {
      const report = this.reportTypes.find(
        (type) => type.key === this.selectedReportType
      )
      return report ? report.value : ''
    }
  }
}
</script>
<style lang="scss">
.report-types {
  max-width: 500px;
}
</style>
